import { ColliStateName } from '@frontend/colli/types';
import { EntityStatusBadge } from '@frontend/components/badge';
import React from 'react';

import useColliStateBadge from './colli-state-badge.controller';

const ID = 'colli-state-badge';

export interface ColliStateBadgeProps {
    state: ColliStateName;
}

export const ColliStateBadge = (props: ColliStateBadgeProps) => {
    const viewProps = useColliStateBadge(props);
    return (
        <EntityStatusBadge
            id={ID}
            label={viewProps.displayName}
            variant={viewProps.variant}
        />
    );
};
